
import { Component, Prop, Vue} from "vue-property-decorator";

import DashboardCardScaffold from "@/components/dashboard/cards/CardScaffold.vue";
import CardItemScaffold from "@/components/dashboard/cards/CardItemScaffold.vue";
import MarketplaceIcon from "@/components/icons/MarketplaceIcon.vue";
import SimplePersonIcon from "@/components/icons/SimplePersonIcon.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import UiButton from "@/components/button/ui-button.vue";
import PlusIcon from "@/components/icons/PlusIcon.vue";

import { User } from "@/generated/graphql";
import RouteNames from "@/entities/RouteNames";
import ItemChipsData from "@/entities/ItemChipsData";

@Component({
  components: {
    DashboardCardScaffold,
    CardItemScaffold,
    MarketplaceIcon,
    SimplePersonIcon,
    CircleWithInitials,
    UiButton,
    PlusIcon,
  },
})
export default class DashboardMarketplace extends Vue {
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({type: Array, default: () => []}) readonly users!: User[];
  @Prop({type: Number, default: undefined}) readonly newTotal?: number;

  routes = RouteNames;

  get noCompany(): boolean {
    return !this.companyId;
  }

  get marketplaceTotal(): string {
    return this.newTotal?.toString() ?? "";
  }

  get newMarketplaceUsersLength(): number | undefined {
    if (!this.users) {
      return undefined;
    }
    return this.users.length;
  }

  get marketplaceUsers(): ItemChipsData[]|string {
    if (!this.users.length) {
      return [];
    }
    return this.users.map((user: User) => {
      return {
        id: user.id,
        name: `${user.given_name} ${user.family_name}`,
        avatar: user.avatar || undefined,
      }
    });
  }

  redirectToMarketplace(): void {
    this.$router.push({name: RouteNames.MARKETPLACE_CONTRACTORS});
  }
}
